<template>
  <div class="widget"
  :style="`
    ${height ? `height: ${height};` : `height: 100%;`}
    ${width ? `width: ${width};` : `width: 100%;`}
    ${widget_color ? `background-color: ${widget_color};` : ''}
    `"
  :class="widget_color?'':'widget-standard-color'"
  >
    <div class="widget-content"
    :style="`
      ${title ? `height: calc(100% - 40px);` : `height: 100%;`}
      ${scrollable ? `overflow: auto;` : `overflow: hidden;`}
    `">
      <div
        :style="`
          ${content_split ? `width: 50%` : `width: 100%`}
          ${background_color ? `background-color: ${background_color}` : ''}
          ${scrollable ? `overflow: auto;` : `overflow: hidden;`}
          overflow: hidden;
          height: 100%;
      `">
        <slot name="widgetContentOne" />
      </div>
      <div v-if="content_split"
        :style="`
          width: 50%;
          ${background_color ? `background-color: ${background_color}` : ''}
          ${scrollable ? `overflow: auto;` : `overflow: hidden;`}
          overflow: hidden;
      `">
        <slot name="widgetContentTwo" />
      </div>
    </div>
    <div class="widget-title">
      <div style="display:flex; position: relative; font-size: 24px">
        <TText
          :value="title"
          size="20"
          font_weight="600"
        />
        <div v-if="badgecount + 1" class="widget-badge">
        {{badgecount}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TText from '@/components/Taktify/TText.component.vue'

export default {
  props: ['width', 'height', 'title', 'scrollable', 'badgecount', 'background_color', 'content_split', 'widget_color'],
  components: {
      TText
  },
  data: () => ({
  }),
}
</script>

<style>
.widget {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  /* width: calc(100% - 60px); */
}
.widget-title {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.widget-content-slot {

}
.widget-content {
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 5px;
  /* overflow: hidden; */
  /* width: 100%; */
  border-radius: 10px;
}
.widget-badge {
  background: white;
  border-radius: 30px;
  position: absolute;
  left: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* font-size: 5px; */
  /* bottom: 10px; */
  /* color: #fff; */
  /* content: attr(badge); */
  height: 28px;
  font-size: 18px;
  min-width: 28px;
  text-align: center;
  margin-left: 5px;
  color: black;
  /* text-align: center; */
  /* padding: 2px; */
  /* margin-bottom: -16px; */
}

.widget-standard-color {
  background-color: var(--v-color-2-5-base);
}
</style>
